import { css } from '@emotion/css';
import { useState } from 'react';
import bgHome from '../../assets/images/bg/bgHome.jpg';
import headerTable from '../../assets/images/headerTable.png';
import classNames from 'classnames';
import { colors } from 'constants/theme';

const VipPage = () => {
    const [tab, setTab] = useState<'TAB1' | 'TAB2' | 'TAB3'>('TAB1');

    const tab1 = [
        { title: 'Điểm tích luỹ', array: ['3,000', '30,000', '200,000', '3,000,000', '10,000,000', '30,000,000'] },
        { title: 'Tiền thưởng tương ứng', array: ['0', '880,000', '5,000,000', '25,000,000', '60,000,000', '200,000,000'] },
        { title: 'Tiền thưởng may mắn hàng tuần', array: ['75,000', '120,000', '500,000', '3,500,000', '5,000,000', '7,500,000'] },
        { title: 'Hỗ trợ nạp rút cấp tốc', array: ['-', '-', '√', '√', '√', '√'] },
        { title: 'Dich vụ chăm sóc khách hàng đặc quyền', array: ['-', '-', '-', '√', '√', '√'] },
        { title: 'Hỗ trợ 24/7', array: ['√', '√', '√', '√', '√', '√'] },
    ];

    const valueVip = [
        { title1: '75,000', title2: '250,000,000', title3: 'VIP 1 - 6' },
        { title1: '120,000', title2: '450,000,000', title3: 'VIP 2 - 6' },
        { title1: '500,000', title2: '1,000,000,000', title3: 'VIP 3 - 6' },
        { title1: '3,500,000', title2: '7,500,000,000', title3: 'VIP 4 - 6' },
        { title1: '5,000,000', title2: '20,000,000,000', title3: 'VIP 5 - 6' },
        { title1: '7,500,000', title2: '50,000,000,000', title3: 'VIP 6' },
    ];

    return (
        <div className={styles.containerAll}>
            <div className={styles.bannerImg}>
                <img src={require('assets/images/VIP-banner.jpeg')} alt="" />
            </div>

            <div className={styles.tableVip}>
                <div className={styles.headerTable}>
                    <div onClick={() => setTab('TAB1')} className={classNames('button', `${tab === 'TAB1' ? 'active' : ''}`)}>
                        <p>ĐẶC QUYỀN VIP</p>
                    </div>
                    <div onClick={() => setTab('TAB2')} className={classNames('button', `${tab === 'TAB2' ? 'active' : ''}`)}>
                        <p>CẤP ĐỘ THƯỞNG VIP</p>
                    </div>
                    <div onClick={() => setTab('TAB3')} className={classNames('button', `${tab === 'TAB3' ? 'active' : ''}`)}>
                        <p>ĐIỀU KIỆN - ĐIỀU KHOẢN</p>
                    </div>
                </div>

                <div className={styles.content}>
                    {tab === 'TAB1' && (
                        <>
                            <div className={styles.item}>
                                <div className={styles.dot} />
                                <p>Niềm vui bất tận cùng phần thưởng không giới hạn, chỉ cần bạn là hội viên của VuiBet.</p>
                            </div>
                            <div className={styles.item}>
                                <div className={styles.dot} />
                                <p>Mỗi vé cược của bạn tại VuiBet sẽ được cộng dồn và tích lũy dài hạn.</p>
                            </div>
                            <div className={styles.item}>
                                <div className={styles.dot} />
                                <p>Điểm tích lũy sẽ dựa theo tiêu chuẩn tương ứng, hệ thống sẽ tự động đánh giá cấp bậc VuiBetVIP của bạn.</p>
                            </div>
                            <div className={styles.item}>
                                <div className={styles.dot} />
                                <p>Chương trình tích lũy điểm thưởng VIP của VuiBet cho phép bạn tích lũy điểm dựa theo tổng số tiền cược và nhanh chóng tiến lên cấp bậc cao hơn.</p>
                            </div>
                            <div className={styles.item}>
                                <div className={styles.dot} />
                                <p>Điểm tích lũy hợp lệ: Tiền cược đạt 500.000 tương ứng với 1 điểm （tổng tiền cược hợp lệ không bao gồm tất cả các game casino)</p>
                            </div>

                            <table className={styles.tableTab1}>
                                {tab1.map((item, index) => (
                                    <tr key={index}>
                                        <td className="title">
                                            <span>{item.title}</span>
                                        </td>
                                        {item.array.map((item, i) => (
                                            <td key={i}>
                                                <span>{item}</span>
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </table>
                        </>
                    )}

                    {tab === 'TAB2' && (
                        <div className={styles.viewVip}>
                            <div className={styles.viewLeft}>
                                <p className={styles.infoYellow}>1.Kiểm tra cấp bậc VIP như thế nào?</p>

                                <p>
                                    Chúng tôi sẽ cập nhật cấp bậc VIP của bạn vào 5:00 mỗi ngày. Bạn có thể nhấp vào <span className={styles.infoYellow}>"Truy vấn cấp độ"</span> để tự kiểm tra chi
                                    tiết về cấp bậc , tiền thưởng, v.v.
                                </p>

                                <p className={styles.infoYellow}>2.Nhận tiền thưởng tương ứng với cấp bậc như thế nào?</p>

                                <p>
                                    Hệ thống sẽ tự động cập nhật tiền thưởng tương ứng với cấp bậc vào 13:00 ngày mùng 3 hàng tháng. Quý hội viên vui lòng nhẫn nại chờ đợi, nếu hệ thống không cập nhật
                                    đúng giờ.
                                </p>

                                <p className={styles.infoYellow}>3.Thế nào là "Tiền thưởng may mắn hàng tuần"?</p>

                                <p>
                                    Chúng tôi sẽ cập nhật <span className={styles.infoYellow}>"Tiền thưởng may mắn hàng tuần"</span> vào 13:00 mỗi thứ 2. Quý hội viên chỉ có thể nhận{' '}
                                    <span className={styles.infoYellow}>"Tiền thưởng may mắn hàng tuần"</span> 1 lần 1 tuần.
                                </p>

                                <p className={styles.infoYellow}>4.Thế nào là "Hỗ trợ nạp rút tiền cấp tốc"?</p>

                                <p>Chúng tôi tuân thủ nguyên tắc dịch vụ gửi và rút tiền theo thời gian thực trong 3 phút. Cấp VIP càng cao thì hiệu quả xử lý càng nhanh.</p>

                                <p className={styles.infoYellow}>5.Thế nào là "Dịch vụ chăm sóc khách hàng độc quyền"?</p>

                                <p>Đối với cấp VIP4 trở lên, chúng tôi có thể mở liên kết dịch vụ khách hàng cho dịch vụ một - một.</p>

                                <p className={styles.infoYellow}>QUY ĐỊNH TIỀN THƯỞNG MAY MẮN HẰNG TUẦN</p>

                                <p>
                                    Dựa trên tổng điểm tích lũy của quý hội viên tính từ 00:00 thứ 2 đến 23:59 chủ nhật hàng tuần. 13h mỗi thứ 2 hàng tuần, hệ thống sẽ tự động cập nhật " tiền thưởng
                                    may mắn " vào tài khoản VuiBet của quý hội viên. VD：Hội viên đạt VIP 2, với số tổng số điểm tích lũy hợp lệ là 1000 trong vòng 1 tuần, sẽ nhận được 120.000vnd vào
                                    mỗi thứ 2 mà không cần đăng ký.
                                </p>
                            </div>

                            <div className={styles.viewRight}>
                                <table className={styles.tableTab1}>
                                    <tr className={styles.headerTableVip}>
                                        <td className={styles.titleTable}>
                                            <span>Tiền thưởng may mắn</span>
                                        </td>
                                        <td className={styles.titleTable}>
                                            <span>Tổng tiền cược yêu cầu</span>
                                        </td>
                                        <td className={styles.titleTable}>
                                            <span>Cấp bậc vip yêu cầu</span>
                                        </td>
                                    </tr>

                                    {valueVip.map((item, index) => (
                                        <tr className={`${index % 2 === 1 ? 'background' : ''}`} key={index}>
                                            <td>
                                                <span>{item.title1}</span>
                                            </td>
                                            <td>
                                                <span>{item.title2}</span>
                                            </td>
                                            <td className={styles.yellow}>
                                                <span>{item.title3}</span>
                                            </td>
                                        </tr>
                                    ))}
                                </table>
                            </div>
                        </div>
                    )}

                    {tab === 'TAB3' && (
                        <>
                            <div className={styles.item}>
                                <p>
                                    - Hội viên không được phép tạo nhiều tài khoản. Một người chơi, 1 địa chỉ IP, một tài khoản, nếu người chơi tạo nhiều tài khoản và thể hiện các hành vi được xem là
                                    lạm dụng tiền thưởng sẽ mất điều kiện nhận ưu đãi này; bị cấm tham gia, bị khóa tài khoản và mất quyền rút tiền.
                                </p>
                            </div>
                            <div className={styles.item}>
                                <p>
                                    - Nếu phát hiện có bất cứ hành vi lợi dụng lỗ hổng của trang web, hoặc cố tình dùng các biện pháp gian lận hay cố ý để đạt lợi nhuận, chiết khấu và khuyến mãi có
                                    ảnh hưởng đến tính công bằng của trang web, chúng tôi có quyền đóng băng tài khoản, hoặc tiền khuyến mãi, đối với các trường hợp có tính nghiêm trọng chúng tôi có
                                    quyền khấu trừ tiền khuyến mãi hoặc lợi nhuận có được từ khuyến mãi.
                                </p>
                            </div>
                            <div className={styles.item}>
                                <p>
                                    - Nếu hội viên có tranh chấp về sự kiện này, để đảm bảo lợi ích của cả hai bên và ngăn chặn hành vi lấy cắp tài khoản chơi, VuiBet có quyền yêu cầu các hội viên
                                    cung cấp cho các tài liệu đầy đủ và chính xác để xác nhận xem có đủ điều kiện hay không.
                                </p>
                            </div>
                            <div className={styles.item}>
                                <p>
                                    - Khi các hội viên tham gia không tuân thủ đầy đủ, hoặc vi phạm hoặc lạm dụng bất kỳ điều khoản nào liên quan đến ưu đãi hoặc khuyến mãi của công ty, hoặc chúng tôi
                                    có bất kỳ bằng chứng nào cho thấy nhóm hoặc cá nhân nào đã đặt một loạt các cược liên quan đến vấn đề gian lận, bất kể kết quả có thể là gì, VuiBet có quyền dừng,
                                    hủy hoặc yêu cầu trả lại tất cả các khoản tiền thưởng mà nhóm hoặc cá nhân này đã được nhận hoặc các hoạt động quảng cáo khác. Ngoài ra, công ty cũng có quyền khấu
                                    trừ chi phí hành chính tương đương với giá trị cổ tức khuyến mãi từ những hội viên này để bù đắp chi phí hành chính của chúng tôi.
                                </p>
                            </div>
                            <div className={styles.item}>
                                <p>- Yêu cầu và chế độ của cấp bậc VIP, VuiBet có quyền thay đổi cuối cùng.</p>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

const styles = {
    infoYellow: css`
        color: #e3cc96 !important;
        font-weight: 300;
        font-size: 13px;
    `,
    yellow: css`
        color: #fcdd0f;

        span {
            color: #fcdd0f !important;
            font-weight: 400 !important;
        }
    `,
    viewLeft: css`
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 15px;
        line-height: 25px;
        p {
            color: white;
            font-weight: 300;
            font-size: 13px;
        }
    `,
    headerTableVip: css`
        background-color: #e3cc96 !important;
    `,
    titleTable: css`
        font-size: 19px !important ;

        span {
            color: #014043 !important;
            font-weight: bold !important;
        }
    `,
    viewRight: css`
        flex: 1;
        display: flex;
        align-self: baseline;
    `,
    viewVip: css`
        display: flex;
        gap: 20px;

        .background {
            background-color: #033a3c;
        }
    `,
    tableTab1: css`
        border-bottom: 1px solid #97896b;
        border-right: 1px solid #97896b;
        width: 100%;
        border-spacing: 0;

        .title {
            width: 400px;
        }

        span {
            color: white;
            font-weight: 300;
        }

        td {
            text-align: center;
            padding: 12px;
            border-top: 1px solid #97896b;
            border-left: 1px solid #97896b;
        }
    `,
    headerTable: css`
        display: flex;
        gap: 10px;
        padding-top: 10px;

        background-image: url(${headerTable});
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        padding: 10px 60px;
        margin-bottom: 50px;

        .button {
            border-bottom-left-radius: 50px;
            width: 100%;
            height: 40px;
            background-image: linear-gradient(to bottom, #2c5490, ${colors.primary}, #2c5490);
            text-align: center;
            border-radius: 10px;
            cursor: pointer;
            &:hover {
                background-image: linear-gradient(to bottom, #5b1313, #931f1f);
            }

            &.active {
                background-image: linear-gradient(to bottom, #5b1313, #931f1f);
            }

            p {
                background: -webkit-linear-gradient(28deg, #ddca8c, #fcf3d4, #ddca8c, #fcf3d4, #ddca8c);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                font-weight: bold;
                font-size: 16px;
                text-transform: uppercase;
                font-weight: 400;
                line-height: 40px;
            }
        }
    `,
    tableVip: css`
        width: 1200px;
        border: 1px solid #faab02;
        padding: 0 50px;
        padding-bottom: 50px;
        background-color: #2c549096;
        align-self: center;
        margin-top: 30px;
    `,
    containerAll: css`
        background: url(${bgHome}) no-repeat;
        background-size: cover;
        height: 100%;
        min-height: 70vh;
        padding: 24px 0;
        display: flex;
        flex-direction: column;
    `,
    bannerImg: css`
        display: flex;
        position: relative;
        img {
            width: 100%;
        }
    `,
    dot: css`
        width: 8px;
        height: 8px;
        border-radius: 10px;
        background-color: white;
    `,
    item: css`
        display: flex;
        align-items: center;
        gap: 10px;
        color: #fff;
        font-size: 14.5px;
        font-weight: 300;
        line-height: 22px;
    `,
    content: css`
        display: flex;
        flex-direction: column;
        gap: 25px;
    `,
};

export default VipPage;
